import { ApolloClient, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { RetryLink } from '@apollo/client/link/retry';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { authService } from '../../auth/authService';
import { GRAPHQL_SERVER_URI } from '../../const/uri';

const httpLink = () => {
    return createUploadLink( {
        uri: GRAPHQL_SERVER_URI,
    } );
};

const retryLink = () => {
    return new RetryLink( {
        attempts: {
            max: 3,
            retryIf: ( error ) => !!error
        }
    } );
};

const authLink = () => {       
    return setContext( ( _, { headers } ) => {
        return {
            headers: {
                ...headers,
                'Apollo-Require-Preflight': 'true',
                authorization: `Bearer ${ authService._auth?.state?.access_token }`,
            }
        };
    } );
};

export let apolloService;

export const createApolloClient = () => { 

    apolloService = new ApolloClient( {
        link: authLink().concat( retryLink() ).concat( httpLink() ),
        cache: new InMemoryCache( )
    } );

    return apolloService;
};
